<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Amino Acid Info</div>
    <div class="my_container">
        <div *ngFor="let element of reqObj.data">
            <a href="{{element['wiki_link']}}">
                <div class="flip">
                    <!-- <div class="front" style="background-color: {{element['bg_color']}}"> -->
                    <div class="front" class="aa-bg {{element['bg_color']}}">
                        <h1 class="text-shadow">{{element['aminoacid']}}</h1>
                        <div class="aa" style="background-image: url({{element['image_path']}})"></div>
                    </div>
                    <div class="back">
                        <h2>{{element['aminoacid']}}</h2>
                        <div class="backgrid">
                            <span>One-Letter</span> <span>{{element['one_letter']}}</span>
                            <span>Three-Letter</span> <span>{{element['three_letter']}}</span>
                            <span>Chemical Class</span> <span>{{element['chemical_class']}}</span>
                            <span>Polarity</span>
                            <div><span class="span-bg {{element['polarity']}}">{{element['polarity']}}</span></div>
                            <span>Charge</span>
                            <div><span class="span-bg {{element['charge']}}">{{element['charge']}}</span></div>
                            <span>Mass</span> <span>{{element['mass']}}</span>
                            <span>RSA</span> <span>{{element['rsa']}}</span>
                            <span>Volume</span> <span>{{element['volume']}}</span>
                            <span>Hydropathy-Index</span> <span>{{element['hydropathy_index']}}</span>
                            <span>Hydropathy</span>
                            <div><span class="span-bg {{element['hydropathy']}}">{{element['hydropathy']}}</span></div>
                            <span># Atoms</span> <span>{{element['atoms']}}</span>
                            <span>Sum-Formula</span> <span>{{element['sum_formula']}}</span>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>